import React from 'react';

/**
 * Ikoner ritade som linjer, i ett och samma formspråk.
 *
 * Alla har samma ruta, samma linjetjocklek och rundade ändar, och ärver
 * färgen från texten omkring. Emoji ersattes just för att de kom från
 * olika håll och aldrig kunde bli enhetliga — eller följa temat.
 */
function Icon({ size = 24, strokeWidth = 1.9, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const HomeIcon = (props) => (
  <Icon {...props}>
    <path d="M3.2 10.4 12 3.6l8.8 6.8" />
    <path d="M5.4 9.6V19a1.4 1.4 0 0 0 1.4 1.4h10.4a1.4 1.4 0 0 0 1.4-1.4V9.6" />
    <path d="M9.6 20.4v-5.6a1.2 1.2 0 0 1 1.2-1.2h2.4a1.2 1.2 0 0 1 1.2 1.2v5.6" />
  </Icon>
);

export const MapIcon = (props) => (
  <Icon {...props}>
    <path d="M9 4.2 3.9 6.3a1 1 0 0 0-.6.9v11.4a.8.8 0 0 0 1.1.75L9 17.4" />
    <path d="m9 4.2 6 2.1M9 4.2v13.2l6 2.4" />
    <path d="m15 19.8 5.1-2.1a1 1 0 0 0 .6-.9v-5" />
    <circle cx="17.4" cy="7.6" r="2.4" />
    <path d="M17.4 12.4c1.9-2.2 2.8-3.6 2.8-4.8a2.8 2.8 0 0 0-5.6 0c0 1.2.9 2.6 2.8 4.8Z" />
  </Icon>
);

export const MeetsIcon = (props) => (
  <Icon {...props}>
    <circle cx="9.4" cy="8" r="3.2" />
    <path d="M3.4 20a6 6 0 0 1 12 0" />
    <path d="M16.4 5.2a3.2 3.2 0 0 1 0 6.2" />
    <path d="M17.8 14.2a6 6 0 0 1 3 5.8" />
  </Icon>
);

export const MessagesIcon = (props) => (
  <Icon {...props}>
    <path d="M8.6 15.6H6.2L3.4 18v-3.2a2.4 2.4 0 0 1-1-2V5.6a2.4 2.4 0 0 1 2.4-2.4h9.6a2.4 2.4 0 0 1 2.4 2.4v1" />
    <path d="M9.6 9.6a2.4 2.4 0 0 1 2.4-2.4h7.2a2.4 2.4 0 0 1 2.4 2.4v5.6a2.4 2.4 0 0 1-2.4 2.4h-2.4l-3 2.6v-2.6h-1.8a2.4 2.4 0 0 1-2.4-2.4Z" />
  </Icon>
);

export const ProfileIcon = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M4.8 20.4a7.2 7.2 0 0 1 14.4 0" />
  </Icon>
);

export const SettingsIcon = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.1 14.4a1.5 1.5 0 0 0 .3 1.65l.05.05a1.8 1.8 0 1 1-2.55 2.55l-.05-.05a1.5 1.5 0 0 0-1.65-.3 1.5 1.5 0 0 0-.9 1.37v.13a1.8 1.8 0 1 1-3.6 0v-.07a1.5 1.5 0 0 0-.98-1.37 1.5 1.5 0 0 0-1.65.3l-.05.05a1.8 1.8 0 1 1-2.55-2.55l.05-.05a1.5 1.5 0 0 0 .3-1.65 1.5 1.5 0 0 0-1.37-.9h-.13a1.8 1.8 0 1 1 0-3.6h.07a1.5 1.5 0 0 0 1.37-.98 1.5 1.5 0 0 0-.3-1.65l-.05-.05a1.8 1.8 0 1 1 2.55-2.55l.05.05a1.5 1.5 0 0 0 1.65.3h.07a1.5 1.5 0 0 0 .9-1.37v-.13a1.8 1.8 0 1 1 3.6 0v.07a1.5 1.5 0 0 0 .9 1.37 1.5 1.5 0 0 0 1.65-.3l.05-.05a1.8 1.8 0 1 1 2.55 2.55l-.05.05a1.5 1.5 0 0 0-.3 1.65v.07a1.5 1.5 0 0 0 1.37.9h.13a1.8 1.8 0 1 1 0 3.6h-.07a1.5 1.5 0 0 0-1.37.9Z" />
  </Icon>
);

export const HeartIcon = ({ filled = false, ...props }) => (
  <Icon {...props} fill={filled ? 'currentColor' : 'none'}>
    <path d="M12 20.3s-7.4-4.6-7.4-9.6a4.3 4.3 0 0 1 7.4-3 4.3 4.3 0 0 1 7.4 3c0 5-7.4 9.6-7.4 9.6Z" />
  </Icon>
);

export const CommentIcon = (props) => (
  <Icon {...props}>
    <path d="M20.4 12.4a7.6 7.6 0 0 1-8.2 7.6 8.6 8.6 0 0 1-3-.7L4.2 20.4l1.2-4.6a7.7 7.7 0 0 1-.8-3.4 7.6 7.6 0 0 1 7.6-7.6 7.6 7.6 0 0 1 8.2 7.6Z" />
  </Icon>
);

export const ShareIcon = (props) => (
  <Icon {...props}>
    <path d="M4 12.6v6a1.8 1.8 0 0 0 1.8 1.8h12.4a1.8 1.8 0 0 0 1.8-1.8v-6" />
    <path d="M16 7.2 12 3.4 8 7.2" />
    <path d="M12 3.8v11.4" />
  </Icon>
);

export const BookmarkIcon = ({ filled = false, ...props }) => (
  <Icon {...props} fill={filled ? 'currentColor' : 'none'}>
    <path d="M6.6 4.6h10.8a1 1 0 0 1 1 1v14.2l-6.4-4.2-6.4 4.2V5.6a1 1 0 0 1 1-1Z" />
  </Icon>
);

export const PlusIcon = (props) => (
  <Icon {...props} strokeWidth={2.2}>
    <path d="M12 5.4v13.2M5.4 12h13.2" />
  </Icon>
);

export const SearchIcon = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="6.4" />
    <path d="m16 16 4.4 4.4" />
  </Icon>
);

export const CloseIcon = (props) => (
  <Icon {...props} strokeWidth={2.1}>
    <path d="M6.4 6.4 17.6 17.6M17.6 6.4 6.4 17.6" />
  </Icon>
);

export const BackIcon = (props) => (
  <Icon {...props}>
    <path d="M14.4 5.6 8 12l6.4 6.4" />
  </Icon>
);

export const LocateIcon = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="3.2" />
    <circle cx="12" cy="12" r="7.6" />
    <path d="M12 1.6v2.8M12 19.6v2.8M22.4 12h-2.8M4.4 12H1.6" />
  </Icon>
);

export const CameraIcon = (props) => (
  <Icon {...props}>
    <path d="M4.4 8.4h2.9l1.4-2.2h6.6l1.4 2.2h2.9a1.6 1.6 0 0 1 1.6 1.6v7.6a1.6 1.6 0 0 1-1.6 1.6H4.4a1.6 1.6 0 0 1-1.6-1.6V10a1.6 1.6 0 0 1 1.6-1.6Z" />
    <circle cx="12" cy="13.6" r="3.4" />
  </Icon>
);

export const ClockIcon = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="8.4" />
    <path d="M12 7.4V12l3 1.8" />
  </Icon>
);

export const CarIcon = (props) => (
  <Icon {...props}>
    <path d="M4.6 15.4h14.8v2.8a1 1 0 0 1-1 1h-1.4a1 1 0 0 1-1-1v-.8H8v.8a1 1 0 0 1-1 1H5.6a1 1 0 0 1-1-1Z" />
    <path d="M5 15.4 6.6 9.6A2 2 0 0 1 8.5 8.2h7a2 2 0 0 1 1.9 1.4l1.6 5.8" />
    <path d="M7.4 12.6h9.2" />
  </Icon>
);

export default Icon;
